import SSOContainer from './SSO.jsx';

export default SSOContainer;
